
import server from '../../public/server/server'
const cloudApi = {
    //----------------------用户-----------------------------------
    userAreaInfo:server.requestPath +  '/analysis/user/areaInfo', // 根据区域获取用户统计
    userCountInfoHour:server.requestPath +  '/analysis/user/countInfoHour', // 获取注册用户和活跃用户(年-月/月-天)
    userCountUserByType:server.requestPath +  '/analysis/user/countUserByType', // 根据类型统计用户
    userDistributedAgeCount:server.requestPath +  '/analysis/user/distributedAgeCount', // 根据区域用户年龄分布统计
    userPhasePercentCount:server.requestPath +  '/analysis/user/phasePercentCount', // 根据区域用户百分比
    userTotalCount:server.requestPath +  '/analysis/user/totalCount', // 用户总数
    //----------------------报警-----------------------------------
	alramAreaInfo:server.requestPath +  '/analysis/alarm/areaInfo', // 根据区域获取事件统计
	alramCountInfoHour:server.requestPath +  '/analysis/alarm/countInfoHour', // 统计事件统计次数(年-月/月-天)
	alramGroupNum:server.requestPath +  '/analysis/alarm/groupNum', // 区域下报警高发区域柱状图(前五)
	alramTotalCount:server.requestPath +  '/analysis/alarm/totalCount', // 报警量和处警量统计
	alramTypeCount:server.requestPath +  '/analysis/alarm/typeCount', // 事件类型统计
	alramWeekDays:server.requestPath +  '/analysis/alarm/weekDays', // 七日内统计
	//----------------------摄像头-----------------------------------
	cameraAreaInfo:server.requestPath +  '/analysis/camera/areaInfo', // 根据区域获取摄像机统计
	cameraCountInfoHour:server.requestPath +  '/analysis/camera/countInfoHour', // 统计事件统计次数(年-月/月-天)
	cameraDayHourNum:server.requestPath +  '/analysis/camera/dayHourNum', // 获取24小时的播放量
	cameraTotalCount:server.requestPath +  '/analysis/camera/totalCount', // 取摄像机总数
	cameraTypeCount:server.requestPath +  '/analysis/camera/typeCount', // 类型统计
	cameraWeekDays:server.requestPath +  '/analysis/camera/weekDays', // 七日内统计
}

export {
    cloudApi
}
